import type { ReactNode } from 'react';
import { useRbac } from '@/hooks/useRbac';

interface PermissionGuardProps {
  permission?: string;
  permissions?: string[];
  /** Mode khi pass `permissions`. Default 'any' (OR). */
  mode?: 'any' | 'all';
  children: ReactNode;
  fallback?: ReactNode;
}

export function PermissionGuard({
  permission,
  permissions,
  mode = 'any',
  children,
  fallback = null,
}: PermissionGuardProps) {
  const { hasPermission, hasAny } = useRbac();

  let allowed = true;
  if (permission) allowed = hasPermission(permission);
  else if (permissions && permissions.length > 0) {
    allowed = mode === 'all'
      ? permissions.every((k) => hasPermission(k))
      : hasAny(permissions);
  }

  return <>{allowed ? children : fallback}</>;
}
